import { Observable } from 'rxjs'

import { request, parseAPIError, DownloadRequest } from '../../common/api'

import * as actionTypes from './actionTypes'
import * as actionCreators from './actionCreators'
import * as tableModelActionTypes from '../../common/table/actionTypes'
import { resolveModelState } from '../../common/table/helpers'

// Fetch

const fetchReportVehicleKilometersTotalEpic = (action$, store) => {
    const tableIdentifier = 'report_vehicle_kilometers_total'

    return action$
        .ofType(actionTypes.FETCH, tableModelActionTypes.CONFIGURATION_CHANGED)
        .filter(action => action.type !== tableModelActionTypes.CONFIGURATION_CHANGED || action.payload.tableIdentifier === tableIdentifier)
        .switchMap(action => {
            const modelState = resolveModelState(tableIdentifier, store.getState(), action)

            return Observable.concat(
                Observable.of({
                    type: actionTypes.FETCH_STARTED,
                }),
                request({
                    method: 'POST',
                    path: `report-vehicle-kilometers-total`,
                    body: {
                        filters: modelState.get('filters').toJS(),
                    },
                })
                    .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportVehicleKilometersTotalFulfilled(ajaxResponse.response)))
                    .catch(error => Observable.of(actionCreators.fetchReportVehicleKilometersTotalRejected(parseAPIError(error))))
                    .takeUntil(action$.ofType(actionTypes.FETCH_CANCELLED, actionTypes.FETCH))
            )
        })
}

// Export

const exportReportVehicleKilometersTotalEpic = (action$, store) =>
    action$.ofType(actionTypes.EXPORT).switchMap(action => {
        const filters = JSON.stringify(action.payload)
        const token = store.getState().auth.get('accessToken')

        new DownloadRequest({
            url: `report-vehicle-kilometers-total/export?filters=${filters}&token=${token}`,
        }).run()

        return Observable.concat(
            Observable.of({
                type: actionTypes.EXPORT_FULFILLED,
            })
        )
    })

export default [fetchReportVehicleKilometersTotalEpic, exportReportVehicleKilometersTotalEpic]
